<template>
  <v-icon class="status-icon"
          :class="[ iconClass, {'inverted': inverted} ]">
    {{statusIcon}}
  </v-icon>
</template>

<script>
  import {statusService} from "@/modules/common/services";

  export default {
    name: "StatusIcon",
    props: {
      status: {
        type: String,
        required: true
      },
      inverted: Boolean
    },
    computed: {
      iconClass() {
        return statusService.statusList[this.status] || '';
      },
      statusIcon() {
        return statusService.statusList[this.status] ? `icon-${this.$options.filters.capitalize(this.status)}` : 'icon-Custom-status';
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .status-icon {
    color: $client_status_custom;
    border-radius: 50%;

    &.inverted {
      color: $white-color-1;
      background-color: $client_status_custom;
    }

    &.lead {
      color: $client_status_lead;

      &.inverted {
        color: $white-color-1;
        background-color: $client_status_lead;
      }
    }

    &.customer {
      color: $client_status_customer;

      &.inverted {
        color: $white-color-1;
        background-color: $client_status_customer;
      }
    }

    &.loyal {
      color: $client_status_loyal;

      &.inverted {
        color: $white-color-1;
        background-color: $client_status_loyal;
      }
    }

    &.inactive {
      color: $client_status_inactive;

      &.inverted {
        color: $white-color-1;
        background-color: $client_status_inactive;
      }
    }
  }
</style>
